import React from 'react'

export default function SponsorPackageHead({ icon, name }) {
  return (
    <div className="flex items-center gap-4 border-2 border-muted-300 bg-muted-100 px-4 py-2">
      <img
        src={icon}
        alt={name}
        className="h-10 w-10 object-contain"
      />
      <h3 className="text-2xl font-black">{name}</h3>
    </div>
  )
}
